// GENERAL
export enum VerifyCodeStepFormFieldsEnum {
  VerificationCode = "verificationCode",
}
